<template>
  <div class="confirmation">
    <div class="appointment-info">
      <div class="appointment">
        <h2>Titans House <span>Appointment Confirmed</span></h2>
        <div class="message">{{ response.message }}</div>
        <div class="appointment-date-info">
          <div>
            <p>Appointment Date</p>
            <div class="date" v-html="response.date" />
          </div>
          <div>
            <p>Appointment Time</p>
            <div class="date" v-html="response.time" />
          </div>
        </div>        
        <div class="primary" v-html="response.primary" />
        <div class="guests" v-if="response.guests !== ''">
          <h3>Additional Guest(s) Info:</h3>
          <div class="guest-info" v-html="response.guests" />
        </div>
        <div class="ui">
          <Button
            text="Cancel Appointment"
            link=""
            v-if="!cancelled"
            @click="cancelAppointment"
          />          
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Button from "@/components/Button";
import axios from "axios";
export default {
  name: "Confirmation",
  components: {
    Button,
  },
  props: {
    response: Object,
  },
  methods: {
    cancelAppointment() {
      this.cancelable = false;
      const params = new URLSearchParams();
      params.append("method", "cancel");
      params.append("id", this.cancelId);
      this.cancelled = true;
      axios
        .post(`${this.$store.state.API}/CancelAppointment.php`, params)
        .then(this.onCancelAppointment);
    },
    onCancelAppointment(response) {
      this.cancelled = false;
      if (response.data.status == "ok") {
        alert("Your appointment has been cancelled.");
        this.cancelled = true;
      } else {
        alert("There was a problem cancelling your appointment.");
      }
    },
  },
  computed: {
    cancelId() {
      return this.response.cancelId;
    },
  },
  data() {
    return {
      cancelled: false,
      /*
      response: {
        message: "Richard, we look forward to hosting you at Titans House!",
        date: "June 24, 2022",
        time: "8:30 am",
        primary:
          "<p class='full-name'>Test F Tesxt L (test d)</p> <p class='email'>richard@channel1media.com</p> <p class='phone'>6546546565</p> <p class='company'>Company</p> <p class='address'>65 Address</p> <p class='notes'>ntoes</p>",
        guests:
          "<p class='guest'>Gf Gl(richard@channel1media.com)</p><p class='guest'>Gf Gl(richard@channel1media.com)</p>",
      },
      /* */
    };
  },
};
</script>

<style lang="scss" scoped>
.ui {
  display: flex;
  gap:40px;
  margin-top:40px;
}
.appointment-date-info {
  display: flex;
  gap:30px;
  text-align: center;
  margin:24px auto;
  p {
    text-transform: uppercase;
    font-weight: 300;
    font-size: 22px;
    margin: 0;
  }
}
.book {
  position: absolute;
  bottom: 30px;
  right: 50px;
  width: calc(100% - 100px);
  @media (min-width: 1000px) {
    width: auto;
    right: 30px;
  }
}
.confirmation {
  flex-direction: column;
  color: var(--white);
  border: 1px solid rgba(113, 113, 113, 0);

  background: linear-gradient(
    90deg,
    rgba(217, 217, 217, 0.03) 0.15%,
    rgba(217, 217, 217, 0.1) 51.51%,
    rgba(217, 217, 217, 0.03) 99.89%
  );
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
  font-size: 1rem;
  overflow: hidden;
  > div {
    font-size: 1rem;
  }
}

.date {
  font-size:42px;
  font-weight: 900;  
  text-transform: uppercase;
  line-height: 1;
}
h2 {
  font-size: 50px;
  font-weight: 900;
  text-transform: uppercase;
  span {
    font-weight: 300;
    color: #4b8ddb;
    margin-left: 15px;
  }
}
h3 {
  margin-bottom: 0;
  font-weight: 600;
}
.primary {
  :deep() {
    p {
      font-weight: 400;
      margin: 8px 0;
      font-size: 1rem;
    }
  }
}
.guest-info {
  :deep() {
    .guest {
      font-size: 1rem;
      margin: 4px 0;
      &:first-child {
        margin-top: 1em;
      }
    }
  }
}
.appointment-info {
  display: flex;
  font-size: 1.25rem;
  flex-direction: column;
  @media (min-width: 1000px) {
    flex-direction: row;
  }
  > div {
    padding: 15px;
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .appointment {
    padding: 60px;
    align-items: center;
    position: relative;
    text-align: center;
    font-weight: 400;
  }
}

svg {
  fill: var(--white);
  width: 130px;
}
</style>